import { css } from "glamor";

export default {
    subheading: css({
        fontWeight: 700,
        color: "rgba(0, 0, 0, 0.85)",
    }),
    title: css({
        // fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: 700,
        color: "rgba(0, 0, 0, 0.65)",
    }),
    divider: css({
        marginTop: 15,
        marginBottom: 15,
        borderTop: "1px dotted gray",
    }),
    secondaryDivider: css({
        borderTop: "1px dotted gray",
    }),
    icon: css({ fontSize: 20, cursor: "pointer" }),
    processesHeader: css({
        display: "flex",
        justifyContent: "space-between",
    }),
    processesTitle: css({
        padding: 16,
        fontSize: 24,
    }),
    processesButtonContainer: css({
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
    }),
    dateColumn: css({
        width: "200px",
    }),
    processNameColumn: css({
        width: "350px",
    }),
    processesMenu: css({
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15) !important",
    }),
    processesMenuItem: css({
        color: "#000",
        fontSize: "16px !important",
        " a": {
            color: "#000",
        },
        ":hover": {
            backgroundColor: "#00000019",
        },
    }),
    tabs: css({
        " .ant-tabs-tab": {
            backgroundColor: "#e1f3fd !important",
            fontWeight: "400 !important",
        },
        " .ant-tabs-tab-active": {
            backgroundColor: "#fff !important",
            fontWeight: "400 !important",
            color: "#1b75bc !important",
        },
    }),
    detailsHeader: css({
        textAlign: "right",
        " .ant-btn-primary": {
            backgroundColor: "#1b75bc",
            borderColor: "#1b75bc",
        },
    }),
    entityInfo: css({
        marginBottom: "1em",
    }),
};
